import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { SALES_CHANNELS } from 'services/consts';

const initialState = [];

export const getOnlineStoreList = createAsyncThunk('onlineStores/fetchAll', async (_, { getState }) => {
	const { onlineStores } = getState();
	if (onlineStores.length > 0) {
		return onlineStores;
	}

	const axiosPrivate = useAxiosPrivate();
	const response = await axiosPrivate.post(SALES_CHANNELS.GET_SALE_CHANNELS);
	return response.data;
});

const onlineStores = createSlice({
	name: 'onlineStores',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getOnlineStoreList.fulfilled, (state, { payload }) => [...payload]);
	}
});

export default onlineStores.reducer;
